module.exports = "/images/pin-sculpture.png?8993f01e782a35c643bd2271277a32f2";